import * as React from 'react';

import { CrehanaTFunction, useTranslation } from '@crehana/i18n';
import TextLink from '@crehana/ui/dist/Buttons/TextLink';
import { Col, Container, Row } from '@crehana/ui/dist/GridV2';

import Item from './Item';

type FAQ = {
  id: number;
  question: string;
  answer: string;
};

const FAQS = (t: CrehanaTFunction): FAQ[] => [
  {
    id: 1,
    question: t('QUESTION_1', '¿Los cupones tienen fecha de caducidad?'),
    answer: t(
      'ANSWER_1',
      'Tus cupones de Crehana no tienen fecha de caducidad. Puedes utilizar tus códigos Crehana en las fechas que desees.',
    ),
  },
  {
    id: 2,
    question: t(
      'QUESTION_2',
      '¿Cuántas veces puedo utilizar cada cupón Crehana?',
    ),
    answer: t(
      'ANSWER_2',
      'Puedes utilizar tu cupón una sola vez para obtener tu descuento. Si cuentas con varios cupones, cada uno tendrá un único uso.',
    ),
  },
  {
    id: 3,
    question: t('QUESTION_3', '¿Por qué no funciona mi cupón Crehana?'),
    answer: t(
      'ANSWER_3',
      'Para que tu descuento en Crehana se haga efectivo, primero debes insertar el número de tu cupón y, posteriormente, ir al checkout para insertar tus datos bancarios. <br/> Ten presente que para utilizar tus cupones de Crehana debes realizar la compra únicamente desde <a href="/cupones">www.crehana.com/cupones.</a>',
    ),
  },
  {
    id: 4,
    question: t(
      'QUESTION_4',
      '¿Cómo puedo ver los cursos o Membresías que compré?',
    ),
    answer: t(
      'ANSWER_4',
      "Para ver las compras que realizaste con tus códigos de descuento, dirígete a la sección Mis Cursos ubicada al lado de tu foto de perfil o, si lo prefieres, puedes ingresar aquí: <a href='/panel/#/mis-cursos' target='_blank'>www.crehana.com/panel/#/mis-cursos.</a> <br /> Si canjeaste un cupón de Crehana sin haberte registrado o haber iniciado tu sesión, no te preocupes. Te recomendamos revisar este artículo para que puedas utilizar tus descuentos en Crehana sin inconvenientes.",
    ),
  },
  {
    id: 5,
    question: t(
      'QUESTION_5',
      '¿Cómo conseguir los mejores descuentos en Crehana?',
    ),
    answer: t(
      'ANSWER_5',
      'Para que estés al tanto de todas las promociones en Crehana solo debes registrar tu correo electrónico y así accederás a los mejores descuentos.',
    ),
  },
  {
    id: 6,
    question: t('QUESTION_6', '¿Aplica para todos los cursos?'),
    answer: t(
      'ANSWER_6',
      'El uso de cupones en Crehana no es válido para cursos, packs o membresías en promoción, debido a que ya cuentan con un precio de descuento aplicado. ',
    ),
  },
];

const FAQSection: React.FC<
  React.PropsWithChildren<{ handleScrollTo(): void }>
> = ({ handleScrollTo }) => {
  const { t } = useTranslation();

  return (
    <section className="py-40 sm:py-80 pb-80 md:pb-120">
      <Container>
        <Row className="flex flex-col items-center">
          <Col xs={12} sm={10} md={8}>
            <div>
              <h2 className="font-h2-md text-center ">
                {t('QUESTION_SECTION_TITLE', {
                  defaultValue: 'Preguntas frecuentes',
                })}
              </h2>
              <ul className="mt-24 sm:mt-52 md:mt-64">
                {FAQS(t).map(el => (
                  <Item key={`question-${el.id}`} item={el} />
                ))}
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <p className="font-legals mt-32 sm:mt-52 md:mt-104 text-gray-dark">
              {t('QUESTION_SECTION_TERMNS_1', 'Conoce los ')}{' '}
              <a
                href="/legal/terminos-y-condiciones/"
                target="_blank"
                className="font-other-link text-secondary-light"
              >
                {t('QUESTION_SECTION_TERMNS_2', 'términos y condiciones')}
              </a>
            </p>
            <TextLink
              className="mt-8"
              css={`
                @media (min-width: 768px) {
                  font-size: 18px !important;
                  line-height: 20px !important;
                }
              `}
              label={t('QUESTION_SECTION_LINK', 'Ver cupones disponibles')}
              onClick={handleScrollTo}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;
